export function initDateImg($) {
  var id;
  $('.date-img--img-container#img-0').addClass('is-active')
  $('.date-img--wrapper a').each(function() {
    $(this).on('mouseover', function() {
      var img = $(this).data("img");
      $('.date-img--img-container').each(function() {
        id = $(this).attr('id');
        if(id == img) {
          $(this).addClass('is-active')
        } else {
          $(this).removeClass('is-active')
        }
      });
    });
  });

  $('.date-img--wrapper#img-0').addClass('active')
  $('.date-img--wrapper').click(function() {
    
    var dropDown = $(this).find('.date-img--text');
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.date-img--inner').find('.date-img--wrapper.active').removeClass('active');
      $(this).addClass('active');
    }
    
  });

  // Défilement automatique : toutes les 5 s on passe à la date suivante (image + texte déplié).
  // Pause au survol / focus du bloc et quand il n'est pas visible ; désactivé si l'utilisateur
  // demande moins d'animations.
  var DELAY = 5000;
  var $block = $('.date-img');
  var $items = $block.find('.date-img--wrapper');
  if ($items.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var current = 0, timer = null, visible = false, paused = false;

  function show(i) {
    current = i;
    $items.removeClass('active').eq(i).addClass('active');
    $block.find('.date-img--img-container').removeClass('is-active').filter('#img-' + i).addClass('is-active');
  }
  function stop() { clearInterval(timer); timer = null; }
  function start() {
    stop();
    if (visible && !paused) timer = setInterval(function () { show((current + 1) % $items.length); }, DELAY);
  }

  $block.on('mouseenter focusin', function () { paused = true; stop(); });
  $block.on('mouseleave focusout', function () { paused = false; start(); });
  // la date survolée ou cliquée devient la position courante
  $items.on('mouseenter click', function () { current = $items.index(this); });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting; start();
    }, { threshold: 0.3 }).observe($block[0]);
  } else { visible = true; start(); }
}
